import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../features/Api/ApiSlice";
import filterReducer from "../features/Task/TaskSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    filter: filterReducer
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddlewares) =>
    getDefaultMiddlewares().concat(apiSlice.middleware),
});
